export default __webpack_public_path__ + "static/media/0008.bf9d9404.WAV";